export enum FilterType {
    numerical,
    date,
    category,
}

interface TypeProperties {
    label: string
    internOnly: boolean
}

export const FilterTypeProperties: {
    [key in FilterType]: TypeProperties
} = {
    [FilterType.numerical]: {label: "Numeric", internOnly: false},
    [FilterType.date]: {
        label: "Date",
        internOnly: false,
    },
    [FilterType.category]: {
        label: "Category",
        internOnly: false,
    },
}
